// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"a4d62310","160":"446879d0","208":"253fb789","293":"33fefeb3","516":"390aeda2","519":"54f097b2","917":"fec39127","946":"2892be86"}[chunkId] + ".chunk.js";
};